module.exports = __webpack_public_path__ + "img/place_bg.481a690d.svg";